var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal--cta",attrs:{"id":"modal-exit-terms"}},[_c('h3',[_vm._v(_vm._s(_vm.pageAttr.cant_verified))]),_vm._v(" "),_c('p',{staticClass:"modal--body"},[_vm._v(_vm._s(_vm.pageAttr.card_decline))]),_vm._v(" "),_c('ButtonCta',{attrs:{"buttonConfig":_vm.exitConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }